<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    progress: number
    maxProgress?: number
    transitionSpeed?: number
  }>(),
  {
    progress: 0,
    maxProgress: 100,
    transitionSpeed: 0.3,
  },
)

const percentage = computed(() => (props.progress / props.maxProgress) * 100)
</script>

<template>
  <div
    class="progress-line prgsline"
    :style="`--percentage:${percentage}%; --transition-speed:${transitionSpeed}s`"
  ></div>
</template>

<style lang="scss" scoped>
.prgsline {
  width: 100%;
  position: relative;
  overflow: hidden;
  --percentage: 0%;
  --clr-line: var(--clr-primary);
  --clr-back: var(--clr-black-2);
  --height: 4px;
  --radius: 4px;
  --radius-progress: 4px;
  border-radius: var(--radius);
  background: var(--clr-back);
  height: var(--height);

  &:before {
    content: '';
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    border-radius: var(--radius-progress);
    height: 100%;
    width: var(--percentage);
    background: var(--clr-line);
    transition: width var(--transition-speed) ease-in-out;
  }
}
</style>
